/*
  set this to true to connect to a locally hosted version of Where's My Package at PORT 5000
  set this to false to connect to my server hosted on Heroku.
*/
export const USE_LOCALHOST = false;
///set resultsPerPage to the number of results to appear on each page once a search is performed
export const resultsPerPage:number = 25;